import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

import { cnatApi, validateMagic } from '../service';
import { Text } from '../components';
import { toast } from 'react-toastify';

function Magic() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const magic = searchParams.get('ref');
      if (magic) {
        try {
          const { data: { token: magicToken } = {} } = await validateMagic({ token: magic });
          cnatApi.defaults.headers.common['Authorization'] = `Bearer ${magicToken}`;
          try {
            localStorage.setItem('token', magicToken);
            navigate('/dashboard');
          } catch (error) {
            navigate('/login');
          }
        } catch (error) {
          toast.error(t('verifyLogin.error'));
          navigate('/login');
        }
      } else {
        navigate('/login');
      }
    })();
  }, [navigate]);

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-white/10 backdrop-blur-sm flex items-center justify-center flex-col gap-4">
      <FadeLoader color="#20539F" size={100} />
      <Text type={'medium'} text={t('verifyLogin.verifying')} className="text-center" />
    </div>
  );
}

export default Magic;
